var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":_vm.bottom,"top":_vm.top,"left":_vm.left,"right":_vm.right},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('span',_vm._g(_vm._b({class:_vm.tooltipClass},'span',attrs,false),on),[_vm._v(" "+_vm._s(_vm.tooltipText)+" ")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.tooltipTitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }